import { createSelector } from '@reduxjs/toolkit';

import {
  getSearchParamsStartDate,
  getSearchParamsNights,
  getSearchParamsFlexDates,
  getSearchParamsFlexNights,
  destinationCityNameForm2Selector,
} from 'src/store/enqueue/selectors';
import type { EmptySearchState } from './types';
import { emptySearchName } from './slices';

import { getHotelsLengthSelector } from '../hotels/selectors';

export const emptySearchSelector = (state): EmptySearchState =>
  state.get(emptySearchName);

export const visibleHotelsOtherRegionSelector = createSelector(
  [emptySearchSelector],
  (state) => state.visibleHotelsOtherRegion,
);

export const allCountHotelsMoreVisibleSelector = createSelector(
  [visibleHotelsOtherRegionSelector, getHotelsLengthSelector],
  (visibleHotelsCount, hotelsCount) => hotelsCount <= visibleHotelsCount,
);

export const visibleHotelsCountSelector = createSelector(
  [visibleHotelsOtherRegionSelector, getHotelsLengthSelector],
  (visibleHotelsCount, hotelsCount) =>
    visibleHotelsCount > hotelsCount ? hotelsCount : visibleHotelsCount,
);

/**
 * Название региона для пустого поиска
 * @description Если был поиск в регион и ничего не нашлось,
 * необходимо отобразить блок пустого поиска, где выводится название региона
 */
export const emptyRegionNameRuSelector = createSelector(
  [emptySearchSelector],
  (state) => state.emptyRegionNameRu,
);

/**
 * Обозначает пустые поиски
 * @description используется вместо селектора hasResults,
 * потому что для пустого поиска по регионам hasResults вернет список отелей по стране и не будет равен false
 */
export const isEmptySearchSelector = createSelector(
  [emptySearchSelector],
  (state) => state.isEmptySearch,
);

/**
 * Пустой поиск в регион
 * @description Если туров в регионе не найдено, будет выполнен поиск по стране
 */
export const isEmptySearchRegionSelector = createSelector(
  [emptySearchSelector],
  (state) => state.isEmptySearch && Boolean(state.emptyRegionNameRu),
);

export const nearestDeparturesSelector = createSelector(
  [emptySearchSelector],
  (state) => state.nearestDepartures,
);
export const hasNearestDeparturesSelector = createSelector(
  [nearestDeparturesSelector],
  (nearestDepartures) => !!nearestDepartures.length,
);

export const recommendedCountriesSelector = createSelector(
  [emptySearchSelector],
  (state) => state.recommendedCountries,
);
export const hasRecommendedCountriesSelector = createSelector(
  [recommendedCountriesSelector],
  (recommendedCountries) => !!recommendedCountries.length,
);

export const recommendedCountriesSearchParamsSelector = createSelector(
  [
    getSearchParamsStartDate,
    getSearchParamsNights,
    getSearchParamsFlexDates,
    getSearchParamsFlexNights,
    destinationCityNameForm2Selector,
  ],
  (startDate, nights, flexDates, flexNights, departureName) => ({
    start_date: startDate,
    nights,
    flex_dates: flexDates,
    flex_nights: flexNights,
    departure_name: departureName,
  }),
);
